import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MenuModel } from 'shared/definition/menu.model';
import { MenuItemModel } from 'shared/definition';
import { NzTreeNodeOptions } from 'ng-zorro-antd/tree';

const apiUrl: string = "api/authorization";
@Injectable({ providedIn: 'root' })
export class AuthorizationApiService {
    constructor(private httpClient: HttpClient) {
    }
    getMenus() {
        return this.httpClient.get<MenuItemModel[]>(`${apiUrl}/menus`);
    }

    getPermissionTree() {
        return this.httpClient.get<NzTreeNodeOptions[]>(`${apiUrl}/permissionTree`)
    }

}
